import { render } from "./EmailCheckList.vue?vue&type=template&id=64700306&scoped=true"
import script from "./EmailCheckList.vue?vue&type=script&lang=js"
export * from "./EmailCheckList.vue?vue&type=script&lang=js"

import "./EmailCheckList.vue?vue&type=style&index=0&id=64700306&scoped=true&lang=css"

import exportComponent from "/usr/frontend/src/app/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-64700306"]])

export default __exports__